<script setup lang="ts">
import { onBeforeMount } from 'vue'
import { RouterView } from 'vue-router'
import { Toaster } from 'vue-sonner'
import { useAuthStore } from '@/stores/auth'

const auth = useAuthStore()

onBeforeMount(async () => {
  await auth.init()
})
</script>

<template>
  <Toaster rich-colors position="top-right" />
  <div v-if="auth.initializing" class="app-boot-spinner" aria-label="Загрузка" role="status">
    <svg
      width="40"
      height="40"
      viewBox="0 0 24 24"
      fill="none"
      class="ui-spinner"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" stroke-width="3" class="ui-spinner__track" />
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke-width="3"
        class="ui-spinner__arc"
        stroke-dasharray="47 16"
        stroke-linecap="round"
      />
    </svg>
  </div>
  <RouterView v-else />
</template>

<style scoped>
.app-boot-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: var(--bg);
}
</style>
